import Debug from 'debug';

const Logger = Debug;
const IS_DEV = Boolean(typeof process !== 'undefined' &&
    process.env &&
    process.env.NODE_ENV !== 'production');
const HAS_CONSOLE = typeof console !== 'undefined' &&
    typeof console.log === 'function' &&
    typeof console.warn === 'function' &&
    typeof console.error === 'function';
function log(level, message, ...args) {
    if (!IS_DEV) {
        return;
    }
    if (HAS_CONSOLE) {
        console[level](message, ...args);
    }
}
function warn(message, ...args) {
    log('warn', `Warning: ${message}`, ...args);
}
function deprecate(version, message, ...args) {
    log('warn', `Deprecation (${version}): ${message}`, ...args);
}
function report(error) {
    setTimeout(() => {
        throw error;
    }, 0);
}

export { log, deprecate, warn, report, Logger };
//# sourceMappingURL=index.js.map
